(function() {
	'use strict';

	angular.module('quantixApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider','$ocLazyLoadProvider' ];

	function stateConfig($stateProvider,$ocLazyLoadProvider) {
		
		$ocLazyLoadProvider
		.config({
			'debug' : false, /*
								 * for debugging ocLazyLoad module
								 * 'true/false'
								 */
			'events' : true, /*
								 * for event ocLazyLoad module
								 * 'true/false'
								 */
			'modules' : [ {
				name : 'quickScreeningModule', /*
									 * injecting
									 * Module for ocLazyLoad
									 */
				/* files for lazy load */
				files : [
						'app/services/analytics/quickScreeningTool.service.js',
						'app/analytics/quickScreeningToolModel/quickScreeningToolMain.controller.js',
						'app/analytics/quickScreeningToolModel/chooseForQSTUploadedData.controller.js',
						'app/analytics/quickScreeningToolModel/quickScreeningToolOutput.controller.js',
						'app/industry/smemargin/smemargin.controller.js']
			} ]
		});
		
		$stateProvider
				.state(
						'quickScreeningToolMain',
						{
							parent : 'app',
							url : '/quickScreeningToolMain',
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/analytics/quickScreeningToolModel/quickScreeningToolMain.html',
									controller : 'QuickScreeningToolMainController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('quickScreeningModule'); /*
																		 * Resolve
																		 * promise
																		 * and
																		 * load
																		 * before
																		 * view
																		 */
										} ],
							}
						})
				.state(
						'quickScreeningToolLanding',
						{
							parent : 'app',
							url : '/quickScreeningToolLanding/:companyCodeToview/:lunchMode',
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/analytics/quickScreeningToolModel/quickScreeningToolLanding.html',
									controller : 'QuickScreeningToolLandingController',
									controllerAs : 'vm'
								}
							}
						})
						.state(
						'quickScreeningToolOutput',
						{
							parent : 'app',
							url : '/quickScreeningToolOutput/:companyId',
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/analytics/quickScreeningToolModel/quickScreeningToolOutputPage.html',
									controller : 'QuickScreeningToolOutputController',
									controllerAs : 'vm'
								}
							}
						});
	}
})();
